export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/NO-2cc8d256c8c3123149af1e40cb05ac45.png";